module.exports = __webpack_public_path__ + "static/media/customer-service.db3e97d8.svg";